import { render } from "./CmsPage.vue?vue&type=template&id=89b08132"
import script from "./CmsPage.vue?vue&type=script&lang=js"
export * from "./CmsPage.vue?vue&type=script&lang=js"

import "./CmsPage.vue?vue&type=style&index=0&id=89b08132&lang=css"

import exportComponent from "/var/www/cms.dealersgear.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__